<template>
  <div id="destination">
    <div class="destinations-container">
      <div class="row">
        <div class="col-12 d-flex flex-column justify-content-center align-items-center w-100">
          <div class="destination-header text-center">
            <h2 class="merriweather-reg-26">Nos destinations</h2>
            <h2 class="merriweather-reg-40">En vogue</h2>
            <p class="merriweather-light-24">Des <span class="merriweather-light-italic-24">privilèges exclusifs</span> vous attendent dans chaque destination.</p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 d-flex justify-content-center tab-wrapper pt-2">
          <div
            v-for="(category, index) in destinationCategories"
            :key="index"
            :class="['category-tab', activeCategory === category ? 'active-tab-desti raleway-bold-p16' : 'raleway-bold-p15']"
            @click="setActiveCategory(category)"
          >
            {{ category }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="pt-4">
          <CardDesti :regions="filteredRegions" data-aos="fade-up" data-aos-duration="900"></CardDesti>
        </div>
      </div>
      <div class="row justify-content-center">
        <a class="hortense-btn-primary raleway-bold-p" :href="'/destination'" target="_blank">Découvrir toutes nos destinations</a>
      </div>
    </div>
  </div>
</template>


<script>

  import CardDesti from '../components/cards/CardDesti.vue';
  import AOS from 'aos';

  export default {
    name: 'destination',
    components: { CardDesti },
    props: {
      destinations: Array
    },
    data() {
      return {
        activeCategory: 'FRANCE'
      }
    },
    computed: {
      destinationCategories() {
        return ['FRANCE', 'OCÉAN INDIEN', 'CARAÏBES', 'AFRIQUE'];
      },
      filteredRegions() {
        return this.destinations?.filter(desti => desti.name.toLowerCase() === this.activeCategory.toLowerCase())?.[0]?.regions || [];
      }
    },
    methods: {
      setActiveCategory(category) {
        this.activeCategory = category;
      }
    },
    mounted(){
      AOS.init();
    }
  }
</script>


<style lang="scss" scope='app/assets/stylesheets/components/destination'>

</style>
